import React, { useState, useRef, useEffect } from "react";
import { Container, Navbar, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import Profile from "./Profile";
import { useSelector, useDispatch } from "react-redux";
import { handleDark } from "../../redux/layout";
import { BiMenu, BiMoon, BiSun, BiBell, BiQuestionMark } from "react-icons/bi";
import { exceptionLog, getBankData, getUserData } from "../../utils/common";
import { userDataProps } from "../../App";
import Notification from "./Notification";
import toastNotify from "../../utils/toastNotify";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from "../../utils/urlConst";

type headerProps = {
  setIsMenuBar: any
}
const Header = ({ setIsMenuBar }: headerProps) => {
  const userProfile = useSelector((state: any) => state.profile.profileImg);
  const userData: userDataProps = getUserData();
  const notificationData = useSelector((state: any) => state.notification.notificationData)?.filter((data: any) => data.ReadStatus === "N");

  const [isNotificationOpen, setIsNotificationOpen] = useState<boolean>(false);
  const notificationRef: any = useRef<undefined>();
  const notificationIconRef: any = useRef<undefined>();

  useEffect(() => {
    const closeNotificationSection = (event: MouseEvent) => {
      if (
        !notificationRef?.current?.contains(event.target) &&
        !notificationIconRef?.current?.contains(event.target)
      ) {
        setIsNotificationOpen(false);
      }
    };
    document.addEventListener("mousedown", closeNotificationSection);
  }, [notificationRef]);

  // const isLanguage = useSelector((state: any) => state.layout.isLanguage);
  // const languageRef: any = useRef<undefined>();
  // const languageIconRef: any = useRef<undefined>();

  // useEffect(() => {
  //   const closeLanguageSection = (event: MouseEvent) => {
  //     if (
  //       !languageRef?.current?.contains(event.target) &&
  //       !languageIconRef?.current?.contains(event.target)
  //     ) {
  //       dispatch(handleLanguage(false))
  //     }
  //   };
  //   document.addEventListener("mousedown", closeLanguageSection);
  // }, [languageRef]);

  const [isProfileMenu, setIsProfileMenu] = useState<boolean>(false);
  const profileMenuRef: any = useRef<undefined>();
  const profileMenuIconRef: any = useRef<undefined>();

  useEffect(() => {
    const closeProfileMenu = (event: MouseEvent) => {
      if (
        !profileMenuRef?.current?.contains(event.target) &&
        !profileMenuIconRef?.current?.contains(event.target)
      ) {
        setIsProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", closeProfileMenu);
  }, [profileMenuRef]);

  const isDark = useSelector((state: any) => state.layout.isDark);
  const screenWidth = useSelector((state: any) => state.layout.currentScreenWidth);
  const bankLogo = useSelector((state: any) => state.layout.bankLogo);
  const dispatch = useDispatch();

  return (
    <>
      <Navbar
        expand="lg"
        className="border-bottom w-100 bg-white position-sticky top-0"
        style={{ borderColor: 'rgb(203 213 225)', zIndex: 999 }}
      >
        <Container>
          <div className="d-flex align-items-center">
            {screenWidth >= 875 ?
              <Navbar.Brand>
                <Link to="/dashboard">
                  <img
                    src={bankLogo.mainLogo}
                    alt="Company-logo"
                    style={{ width: bankLogo.mainLogoWidth, height: bankLogo.mainLogoheight }}
                  />
                </Link>
              </Navbar.Brand>
              :
              <div className="header-icon rounded-circle" onClick={() => setIsMenuBar(true)}>
                <BiMenu />
              </div>
            }
          </div>

          <div className="ml-auto d-flex align-items-center">

            {/* {bankDtl.UserManualType === "R" &&
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 100, hide: 100 }}
                overlay={<Tooltip id="button-tooltip">
                  User Manual
                </Tooltip>}
              >
                <div
                  className="header-icon rounded-circle"
                  onClick={() => {
                    downloadUserManual();
                  }}
                >
                  <BiQuestionMark className="text-slate-700" />
                </div>
              </OverlayTrigger>
            } */}

            <div
              className="header-icon ms-2 rounded-circle"
              onClick={() => {
                dispatch(handleDark(!isDark));
              }}
            >
              {isDark ? <BiSun /> : <BiMoon />}
            </div>

            <div
              className="header-icon mx-2 rounded-circle position-relative"
              onClick={() => setIsNotificationOpen(!isNotificationOpen)}
              ref={notificationIconRef}
            >
              <BiBell />
              {notificationData !== null && notificationData?.length !== 0 && notificationData?.length !== undefined &&
                <div className="bg-orange rounded-circle position-absolute text-xs d-flex justify-content-center align-items-center text-white" style={{ width: 15, height: 15, top: 0, right: 0 }}>{notificationData?.length}</div>
              }
            </div>
            <div
              onClick={() => setIsProfileMenu(!isProfileMenu)}
              ref={profileMenuIconRef}
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center gap-1"
            >
              {userProfile === null || userProfile === "" ? (
                <Image src='/imgaes/profile.png' alt={userData?.FirstName} roundedCircle style={{ width: 40, aspectRatio: "2/2" }} />
              ) : <Image src={userProfile !== null ? userProfile : userData?.Photo} alt={userData?.FirstName} roundedCircle style={{ width: 40, aspectRatio: "2/2" }} />}

              {userData?.FirstName}
            </div>
          </div>
        </Container>
      </Navbar >

      {isNotificationOpen && (<Notification notificationRef={notificationRef} isNotificationOpen={isNotificationOpen} setIsNotificationOpen={setIsNotificationOpen} />)
      }
      {isProfileMenu && (<Profile profileMenuRef={profileMenuRef} isProfileMenu={isProfileMenu} setIsProfileMenu={setIsProfileMenu} userProfile={userProfile} />)}
    </>
  );
};

export default Header;
